<template>
  <v-card class="pa-4 card" :disabled="noteLoading">
    <div
      style="position: absolute; left: 48%; z-index: 3; top: 45%"
      v-if="noteLoading"
    >
      <v-progress-circular size="30" indeterminate></v-progress-circular>
    </div>

    <h3 class="text-center my-2">
      {{ isEditing ? $t('Atualizar nota') : $t('Nova nota') }}
    </h3>

    <v-form ref="form">
      <v-row class="ma-0" align="center" dense>
        <v-col cols="12" sm="8">
          <span class="text ml-1">{{ $t('Título') }}</span>
          <v-text-field
            hide-details="auto"
            class="primary-input"
            :placeholder="$t('Adicione um título a atualização')"
            v-model="note.title"
            outlined
            :rules="[(v) => !!v || 'Título obrigatório']"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-text-field>
        </v-col>

        <v-col cols="12" sm="4">
          <span class="text ml-1">{{ $t('Data da atualização') }}</span>
          <v-menu
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                hide-details="auto"
                class="primary-input"
                placeholder="00/00/0000"
                :value="formatDate(note.patchDate)"
                outlined
                readonly
                v-bind="attrs"
                v-on="on"
                :rules="[(v) => !!v || 'Data de atualização obrigatória']"
              >
                <template #message="{ message }">
                  {{ $t(message) }}
                </template>
              </v-text-field>
            </template>
            <v-date-picker locale="pt" v-model="note.patchDate">
            </v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12">
          <span class="text ml-1">{{ $t('Descrição') }}</span>
          <v-textarea
            hide-details="auto"
            class="primary-input"
            :placeholder="$t('Adicione aqui a nota da atualização')"
            v-model="note.note"
            outlined
            :rules="[(v) => !!v || 'Descrição obrigatória']"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-textarea>
        </v-col>
      </v-row>

      <div class="d-flex justify-end">
        <v-btn class="clear-button" depressed @click="$emit('close')">
          {{ $t('Cancelar') }}
        </v-btn>
        <v-btn
          @click="submit"
          :loading="loading"
          class="primary-button"
          depressed
        >
          {{ isEditing ? $t('Atualizar') : $t('Adicionar') }}
        </v-btn>
      </div>
    </v-form>
  </v-card>
</template>

<script>
import moment from 'moment'
import FormatDate from '../../../../Utils/FormatDate'
import ApiService from '../../../../services/ApiService'

export default {
  name: 'ManagePatchNotes',

  props: {
    noteId: Number,
  },

  created() {
    if (this.noteId) {
      this.isEditing = true

      this.getNote()
    }
  },

  data() {
    return {
      noteLoading: false,
      loading: false,
      apiService: new ApiService(),
      isEditing: false,
      note: {
        patchDate: moment().format('YYYY-MM-DD'),
      },
    }
  },

  methods: {
    getNote() {
      this.noteLoading = true
      this.apiService
        .get(`patchNote/${this.noteId}`)
        .then((response) => {
          this.note = response.content

          this.note.patchDate = this.note.patchDate
            ? this.note.patchDate.split('T')[0]
            : ''

          this.noteLoading = false
        })
        .catch(() => {
          this.noteLoading = false
        })
    },

    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true

        if (this.isEditing) {
          this.apiService
            .put('patchNote/edit', this.note)
            .then(() => {
              this.$toast.success(
                this.$t('Nota de atualização atualizada com sucesso!')
              )
              this.$emit('confirm')
              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          this.apiService
            .post('patchNote/add', this.note)
            .then(() => {
              this.$toast.success(
                this.$t('Nota de atualização adicionada com sucesso!')
              )
              this.$emit('confirm')
              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        }
      }
    },

    formatDate(date) {
      return FormatDate.dateTime(date)
    },
  },
}
</script>

<style scoped>
.card {
  border-radius: 10px !important;
}
</style>
